<template>
  <item-detail-base item-title="瑞普乐园">
    <div class="img-list">
      <div class="social-title">
        <span>瑞普乐园</span>
      </div>
      <div class="pre" @click="pre"><i class="el-icon-arrow-left"></i></div>
      <div class="el-image">
        <el-image :src="'http://'+UrlList[0].photoUrl" fit="cover" :title="UrlList[0].description" class="first" v-if="UrlList[0]"></el-image>
        <el-image :src="'http://'+UrlList[1].photoUrl" fit="cover" :title="UrlList[1].description" class="first" v-if="UrlList[1]"></el-image>
        <el-image :src="'http://'+UrlList[2].photoUrl" fit="cover" :title="UrlList[2].description" class="first" v-if="UrlList[2]"></el-image>
        <el-image :src="'http://'+UrlList[3].photoUrl" fit="cover" :title="UrlList[3].description" class="list-type" v-if="UrlList[3]"></el-image>
        <el-image :src="'http://'+UrlList[4].photoUrl" fit="cover" :title="UrlList[4].description" class="list-type" v-if="UrlList[4]"></el-image>
        <el-image :src="'http://'+UrlList[5].photoUrl" fit="cover" :title="UrlList[5].description" class="list-type" v-if="UrlList[5]"></el-image>
        <el-image :src="'http://'+UrlList[6].photoUrl" fit="cover" :title="UrlList[6].description" class="list-type" v-if="UrlList[6]"></el-image>
      </div>
      <div class="next" @click="next"><i class="el-icon-arrow-right"></i></div>
    </div>
  </item-detail-base>
</template>

<script>
  import ItemDetailBase from "../Common/ItemDetailBase";
  export default {
    name: "HomeEdgn",
    components: {ItemDetailBase},
    data(){
      return{
        data:{
          'pageSize':7,
          'pageNumber':0
        },
        UrlList:{},
        Page:null
      }
    },
    created() {
      this.GetData(this.data)
    },
    methods:{
      GetData(data){
        this.$axios.post('/api/fairyland/getList',data).then(res=>{
          console.log(res);
          this.UrlList=res.data.data.records
          this.Page=res.data.data.total
        })
      },
      pre(){
        this.data.pageNumber--;
        if(this.data.pageNumber<0){
          this.$message.error('没有上一页，返回第一页')
          this.data.pageNumber=0;
        }
        this.GetData(this.data)
      },
      next(){
        this.data.pageNumber++;
        if(this.data.pageNumber>this.Page){
          this.$message.error('没有下一页，返回第一页')
          this.data.pageNumber=0;
        }
        this.GetData(this.data)
      }
    }
  }
</script>

<style lang="less" scoped>
  .img-list{
    position: relative;
    .pre{
      width: 60px;
      height: 60px;
      border: 1px solid gray;
      border-radius: 50%;
      position: absolute;
      text-align: center;
      top: 45vh;
      left: -100px;
      &:hover{
          color: #188ACB;
          border: 1px solid #188ACB;
      }
      i{
        font-size: 32px;
        line-height: 60px;
      }
    }
    .next{
      width: 60px;
      height: 60px;
      border: 1px solid gray;
      border-radius: 50%;
      text-align: center;
      position: absolute;
      top: 45vh;
      right: -100px;
      &:hover{
          color: #188ACB;
          border: 1px solid #188ACB;
      }
      i{
        font-size: 32px;
        line-height: 60px;
      }
    }
    .el-image{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .list-type{
        width: 17.8vw;
        height: 239px;
        border-radius: 2px;
        padding-top: 18px;
      }
      .first{
        width: 24vw;
        height: 239px;
        border-radius: 2px;
        padding-top: 10px;
      }
    }
    .first{
      width: 24.5vw;
      height: 249px;
    }
  }
  .social-title{
    margin: 0 auto;
    text-align: center;
    padding: 30px 0 60px 0;
    span{
      width: 132px;
      height: 32px;
      font-size: 32px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 48px;
      letter-spacing: 1px;
    }
  }
</style>